import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { capi } from "@/lib/api";

const CustomerCtx = createContext(null);
const KEY = "kys_customer_token";

export function CustomerProvider({ children }) {
  const [customer, setCustomer] = useState(null);
  const [ready, setReady] = useState(false);

  const refresh = useCallback(async () => {
    if (!localStorage.getItem(KEY)) { setCustomer(null); setReady(true); return; }
    try {
      const { data } = await capi.get("/account/me");
      setCustomer(data);
    } catch (e) {
      if ([401, 403].includes(e?.response?.status)) { localStorage.removeItem(KEY); setCustomer(null); }
    } finally { setReady(true); }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const login = async (email, password) => {
    const { data } = await capi.post("/account/login", { email, password });
    localStorage.setItem(KEY, data.token);
    setCustomer(data.user);
    return data.user;
  };

  const logout = async () => {
    try { await capi.post("/account/logout"); } catch (e) { /* ignore */ }
    localStorage.removeItem(KEY);
    setCustomer(null);
  };

  return <CustomerCtx.Provider value={{ customer, ready, login, logout, refresh }}>{children}</CustomerCtx.Provider>;
}

export const useCustomer = () => useContext(CustomerCtx);
